import { __assign, __rest } from "tslib";
import React from "react";
import { useVSETHContext } from "../VSETHContext/VSETHContext";
export var Logo = function (_a) {
  var _b = _a.size,
      size = _b === void 0 ? 32 : _b,
      _c = _a.variant,
      variant = _c === void 0 ? "logo" : _c,
      _d = _a.format,
      format = _d === void 0 ? "svg" : _d,
      imgProps = __rest(_a, ["size", "variant", "format"]);

  var _e = useVSETHContext(),
      globID = _e.globID,
      static_url = _e.static_url;

  return React.createElement("img", __assign({
    height: size,
    src: static_url + "/assets/" + globID + "/" + variant + "." + format
  }, imgProps));
};